import EventBus from "@/utils/event-bus";
import orgApi from "@/modules/Organizations/api/";
import * as types from "@/modules/Organizations/store/mutation-types";
import termApi from "@/modules/Terminals/api/";

export const defaultModuleName = "organization";

export default {
  namespaced: true,

  state: {
    currentOrganizationTerminals: [],
    currentTerminal: "",
    currentTerminalServices: "",
    current_orgs: null,
    orgsAmount: null,
    organizationTerminalLoading: false,
    list: {
      start: 0,
      perPage: 25,
      total: 0,
      items: []
    }
  },

  getters: {
    currentOrganizationTerminals(state) {
      return state.currentOrganizationTerminals;
    },

    listOfOrganization(state) {
      return state.list;
    },
    organizationTerminalLoading(state) {
      return state.organizationTerminalLoading;
    },
    myOrgs(state) {
      if (state.current_orgs === null) {
        return [];
      }
      return state.current_orgs;
    },
    orgsAmount(state) {
      return state.orgsAmount;
    }
  },

  mutations: {
    [types.CURRENT_ORGANIZATION_TERMINALS]: (
      state,
      currentOrganizationTerminals
    ) => {
      return (state.currentOrganizationTerminals = currentOrganizationTerminals);
    },

    [types.UPDATE_AUTH_USER_ORGANIZATIONS]: (state, organizations) => {
      state.current_orgs = organizations;
    },
    [types.TERMINALS_LOADING]: (state, organizationTerminalLoading) => {
      state.organizationTerminalLoading = organizationTerminalLoading;
    },

    [types.CLEAR_STATE]: state => {
      state.current_orgs = null;
    },
    [types.CLEAR_TERMINALS]: state => {
      console.warn('clearTerminals')
      state.currentOrganizationTerminals = [];
    },
    [types.UPDATE_ORGS_AMOUNT]: (state, amount) => {
      state.orgsAmount = amount;
    },
    [types.UPDATE_ORGANIZATIONS_PAGE]: (
      state,
      items,
      start,
      perPage,
      totalCount
    ) => {
      state.list = {
        start,
        perPage,
        totalCount,
        items
      };
    }
  },

  actions: {
    clearState({ commit }) {
      commit(types.CLEAR_STATE);
    },

    async loadCurrentOrganizationTerminals({ commit, dispatch }, payload) {
      try {
        let { org_id, params = {} } = payload;
        commit(types.TERMINALS_LOADING,true);
        const resp = await termApi.getOrganizationsTerminals(
          org_id,
          (params = {})
        );
        commit(types.CURRENT_ORGANIZATION_TERMINALS, resp.data);
        EventBus.$emit("organization:terminals::loaded");
      } catch (e) {
        console.log("organization:terminals::loading error ");
      }
      finally {
        commit(types.TERMINALS_LOADING, false);
      }
    },

    async loadMyOrgs({ commit }) {
      const resp = await orgApi.getMyOrganizations();
      commit(types.UPDATE_AUTH_USER_ORGANIZATIONS, resp.data);

      EventBus.$emit("organization::loaded");
    },

    async list({ dispatch, commit }, payload = {}) {
      let { search = "", limit = 25, offset = 0 } = payload;
      const resp = await orgApi.getOrganizations({
        search: search,
        limit: limit,
        offset: offset
      });

      commit(types.UPDATE_ORGANIZATIONS_PAGE, {
        items: resp.data,
        start: offset,
        perPage: limit,
        totalCount: resp.headers["x-total-count"] * 1
      });
      commit(types.UPDATE_ORGS_AMOUNT, resp.headers["x-total-count"]);
      return resp;
    }
  }
};
